export const existsOrNull = (t, key) => {
  const translation = t(key)

  if (translation === key) {
    return null
  }

  return translation
}
